<template>
   <v-footer dark padless class="mt-7">
       <v-layout row>
           <v-flex xs12 sm12 md12 lg12>
               <v-card
                    flat
                    tile
                    class="grey darken-3 white--text text-center">
                    <v-card-text>
                        <v-btn
                        v-for="icon in icons"
                        :key="icon.id"
                        class="mx-4 white--text"
                        icon
                        :href="icon.url" target="_blank"
                        >
                        <v-icon size="24px">{{ icon.icon }}</v-icon>
                        </v-btn>
                    </v-card-text>

                    <v-card-text class="white--text pt-0 my-3">
                        Acesse nossos canais através das redes sociais acima.
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-text class="white--text">
                        {{ new Date().getFullYear() }} — Desenvolvido por <a href="https://www.linkedin.com/in/douglas-martins-oliveira-26009895/"><strong>Douglas</strong> </a> v07.01.26
                    </v-card-text>
                    </v-card>
           </v-flex>
       </v-layout>
    
  </v-footer>
</template>

<script>
    export default {
         data: () => ({
      icons: [
        {id: 0, icon: 'mdi-facebook', url: 'https://www.facebook.com/barberiaclassicalisboa'},
        //{icon: 'mdi-twitter', url: ''},
        //{icon: 'mdi-linkedin', url: ''},
        {id: 1, icon: 'mdi-instagram', url: 'https://www.instagram.com/lisboabarbearia/'},
        {id: 2, icon: 'mdi-whatsapp', url: 'https://api.whatsapp.com/send?phone=554298607670'},
        
      ],
    }),
    }
</script>

<style lang="scss" scoped>

</style>